import { render, staticRenderFns } from "./SendRuleBaseAnswer.vue?vue&type=template&id=82e6de10&scoped=true&"
import script from "./SendRuleBaseAnswer.vue?vue&type=script&lang=js&"
export * from "./SendRuleBaseAnswer.vue?vue&type=script&lang=js&"
import style0 from "./SendRuleBaseAnswer.vue?vue&type=style&index=0&id=82e6de10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e6de10",
  null
  
)

export default component.exports